var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoCircleGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7258_8783)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12.5391C9.31371 12.5391 12 9.85277 12 6.53906C12 3.22535 9.31371 0.539062 6 0.539062C2.68629 0.539062 0 3.22535 0 6.53906C0 9.85277 2.68629 12.5391 6 12.5391ZM6 11.0391C8.48528 11.0391 10.5 9.02434 10.5 6.53906C10.5 4.05378 8.48528 2.03906 6 2.03906C3.51472 2.03906 1.5 4.05378 1.5 6.53906C1.5 9.02434 3.51472 11.0391 6 11.0391ZM6.75 4.28906C6.75 4.70327 6.41421 5.03906 6 5.03906C5.58579 5.03906 5.25 4.70327 5.25 4.28906C5.25 3.87485 5.58579 3.53906 6 3.53906C6.41421 3.53906 6.75 3.87485 6.75 4.28906ZM6 5.78906C5.58579 5.78906 5.25 6.12485 5.25 6.53906V8.78906C5.25 9.20327 5.58579 9.53906 6 9.53906C6.41421 9.53906 6.75 9.20327 6.75 8.78906V6.53906C6.75 6.12485 6.41421 5.78906 6 5.78906Z",
    fill: "#9FA3B5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7258_8783"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.539062)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircleGrey);
export default __webpack_public_path__ + "static/media/info-circle-grey.40c7e8be77585fef51a721fb9322418a.svg";
export { ForwardRef as ReactComponent };